// ChoralIdentityPanel.jsx
import React from "react";
import EditableField from "./EditableField";

function unknown(label) {
  return (
    <div className="ce-field">
      <div className="ce-field__label">{label}</div>
      <div className="ce-field__value ce-field__value--unknown">Not yet known</div>
    </div>
  );
}

export default function ChoralIdentityPanel({ work, readOnly = false, onSaved, apiBase }) {
  return (
    <section className="ce-panel" data-testid="ce-identity-panel">
      <h3 className="ce-panel__heading">Identity</h3>
      <EditableField
        workId={work.id}
        field="title"
        label="Title"
        value={work.title}
        readOnly={readOnly}
        onSaved={onSaved}
        apiBase={apiBase}
      />
      <EditableField
        workId={work.id}
        field="composer"
        label="Composer"
        value={work.composer}
        readOnly={readOnly}
        onSaved={onSaved}
        apiBase={apiBase}
      />
      {work.publisher ? (
        <div className="ce-field">
          <div className="ce-field__label">Publisher</div>
          <div className="ce-field__value">{work.publisher}</div>
        </div>
      ) : (
        unknown("Publisher")
      )}
      {work.catalog_number ? (
        <div className="ce-field">
          <div className="ce-field__label">Catalog #</div>
          <div className="ce-field__value">{work.catalog_number}</div>
        </div>
      ) : (
        unknown("Catalog #")
      )}
      <div className="ce-field">
        <div className="ce-field__label">Catalog ID</div>
        <div className="ce-field__value" style={{ fontFamily: '"IBM Plex Mono", monospace', fontSize: "0.8rem" }}>
          {work.id}
        </div>
      </div>
    </section>
  );
}
